module.exports = __webpack_public_path__ + "static/media/ImgNovedades210805_1.5643de56.jpg";